import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './catalog.component'

import Components     from './components'
import CatalogContent from './catalog-content'

let module = angular.module('catalog', [
  uiRouter,
  Components,
  CatalogContent
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('vehicle.catalog', {
      url: '/catalog',
      component: 'catalog',
      redirectTo: 'vehicle.catalog.appsAndServices',
      authenticate: true
    })
})

.component('catalog', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/index.js